import { render, staticRenderFns } from "./GSchoolClassChangeToolBar.vue?vue&type=template&id=0ffe10e1&scoped=true&"
import script from "./GSchoolClassChangeToolBar.vue?vue&type=script&lang=ts&"
export * from "./GSchoolClassChangeToolBar.vue?vue&type=script&lang=ts&"
import style0 from "./GSchoolClassChangeToolBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffe10e1",
  null
  
)

export default component.exports